














import Vue from 'vue';

export default Vue.extend({
  props: {
    grey: {
      default: false,
      type: Boolean,
    },
    multiExpand: {
      default: false,
      type: Boolean,
    },
    press: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    this.initializeAccordion();
  },
  updated(): void {
    this.initializeAccordion();
  },
  methods: {
    /* eslint-disable @typescript-eslint/ban-ts-comment */
    initializeAccordion(): void {
      Vue.nextTick(() => {
        // will be moved to vue soon©. this is horrible.
        // @ts-ignore
        clearInterval(window.updateAccordionDom);
        // @ts-ignore
        window.initializeAccordionCount = 50;
        // @ts-ignore
        window.updateAccordionDom = setInterval(() => {
          // @ts-ignore
          if(window.initializeAccordionCount-- < 0 || typeof $(document).foundation === `function`) {
            // @ts-ignore
            $(document).foundation();
            // @ts-ignore
            clearInterval(window.updateAccordionDom);
          }
        }, 100);
      });
    },
    /* eslint-enable */
  },
});
